import React from 'react';
import { default as Form } from '../../components/connectedForm';
import * as input from '../../components/connectedForm/inputComponents';

export default () => {
  return (
    <React.Fragment>
      <Form.Row>
        {/* First Column */}
        <Form.Fieldset cols={4 / 8}>
          <Form.Legend label="Direct Debit" />
          <Form.Field dataid="directDebit.frequency" component={input.Dropdown} label="Direct Debit Frequency" />
          <Form.Field dataid="directDebit.startDate" component={input.DateField} label="Start Date" />
          <Form.Field dataid="directDebit.cancellationDate" component={input.DateField} label="Cancellation Date" />
          <Form.Field dataid="directDebit.reference" component={input.BlurTextField} label="Reference" />
        </Form.Fieldset>

        {/* Second Column */}
        <Form.Fieldset cols={4 / 8}>
          <Form.Legend label="Bank Details" />
          <Form.Field dataid="directDebit.accountName" component={input.BlurTextField} label="Account Name" />
          <Form.Field dataid="directDebit.sortCode" component={input.BlurTextField} label="Sort Code" />
          <Form.Field dataid="directDebit.accountNumber" component={input.BlurTextField} label="Account Number" />
        </Form.Fieldset>
      </Form.Row>

      <Form.Row>
        <Form.Fieldset cols={4 / 8}>
          <Form.Legend label="Last Direct Debit Request Details" />
          <Form.Field
            dataid="directDebit.lastRequestDate"
            component={input.DateField}
            readOnly={true}
            label="Last Requested Date"
          />
          <Form.Field
            dataid="directDebit.lastRequestAmount"
            component={input.ValueField}
            readOnly={true}
            label="Last Requested Amount"
            type="currency"
          />
        </Form.Fieldset>
      </Form.Row>
    </React.Fragment>
  );
};
